module.exports = __webpack_public_path__ + "static/media/pic-marketing.405798a1.svg";